import { render, staticRenderFns } from "./TestDataMainFormList.vue?vue&type=template&id=ae4c4f5e"
import script from "./TestDataMainFormList.vue?vue&type=script&lang=js"
export * from "./TestDataMainFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae4c4f5e')) {
      api.createRecord('ae4c4f5e', component.options)
    } else {
      api.reload('ae4c4f5e', component.options)
    }
    module.hot.accept("./TestDataMainFormList.vue?vue&type=template&id=ae4c4f5e", function () {
      api.rerender('ae4c4f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/onetomany/TestDataMainFormList.vue"
export default component.exports